// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 2179 ? "KluczykiLandingApp" : chunkId) + ".js?id=" + {"2179":"d9bf4097f7b5d651","3078":"cd1f0c7819cb4fd3","4945":"fb73b5ae5545883d","7637":"bd244f3d5d8177ce","8443":"61ca8677546bbd3c"}[chunkId] + "";
};